import { render, staticRenderFns } from "./CreateFollowUpTicket.vue?vue&type=template&id=4ee89918&scoped=true"
import script from "./CreateFollowUpTicket.vue?vue&type=script&lang=js"
export * from "./CreateFollowUpTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee89918",
  null
  
)

export default component.exports